<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :is-required="isRequired"
    :class-label="classLabel"
    :class-wrapper="classWrapper"
  >
    <InputDate
      v-model="timestamps"
      :placeholder="placeholder"
      :disabled="disabled"
      type="format"
      :range="true"
      format="DD/MM/YYYY"
    />
  </FieldWrapper>
</template>

<script>
import InputDate from './InputDate'
import FieldWrapper from '@/components/forms/FieldWrapper'

export default {
  components: {
    InputDate,
    FieldWrapper
  },

  props: {
    value: {},

    state: {
      type: Object
    },

    label: {
      type: String
    },

    placeholder: {
      type: String
    },

    isRequired: {
      type: Boolean
    },

    disabled: {
      type: Boolean,
      default: false
    },

    classLabel: {
      type: String
    },

    classWrapper: {
      type: String
    }
  },

  data () {
    return {
      timestamps: this.value
    }
  },

  watch: {
    value: {
      deep: true,
      handler (value) {
        this.timestamps = value
      }
    },

    timestamps: {
      deep: true,
      handler (timestamps) {
        this.$emit('input', timestamps)
      }
    }
  }
}

</script>
